import * as yup from 'yup';
import { ProductCategory } from '@models';

export const schema = yup.object({
  // BASIC INFORMATION
  is_visible: yup.boolean(),
  name: yup.string().required('Product name is required.'),
  categories: yup.array().required('Categories is required.'), // Subset of categories - only the subcategories of Menu1.
  zones: yup.array().required('Zones is required.'), // Subset of categories - only the subcategories of Zones.
  sku: yup.string().required('Sku is required.'),
  weight: yup.number().required('Weight is required').typeError('Weight number is required.').positive('Weight must be a positive number'),
  description: yup.string(),
  // PRICING
  price: yup.number().required('Price is required.').typeError('Price number is required.').positive('Price must be a positive number'),
  cost_price: yup
    .number()
    .required('Cost Price is required.')
    .typeError('Cost Price number is required.')
    .positive('Cost Price must be a positive number'),
  // SEO
  page_title: yup.string(),
  meta_description: yup.string(),
  // CUSTOM FIELDS
  custom_fields: yup.object({
    display_name: yup.string().required('Display name is required.'),
    display_region: yup.string(),
    modal_promo_banner_text: yup.string(),
    display_badge: yup.string(),
    display_tasting_tags: yup.string(),
    display_volume: yup.string(),
    display_alcoholic_content: yup.string(),
    pack_type: yup.string(),
    parent_product_sku: yup.string(),
    standard_drink_count: yup
      .number()
      .min(0)
      .required('Standard drink count number is required.')
      .typeError('Standard drink count number is required.'),
    menu_tile_promo_text: yup.string(),
    save_text: yup.string(),
    display_menu_tile: yup.boolean(),
    short_description: yup.string().required('Short description is required.').typeError('Short description is required.'),
    brand: yup.string(),
    is_bundle: yup.boolean(),
    product_lists: yup.string(),
    reporting_category_1: yup.string().required('Main Category is required.').typeError('Main Category is required.'),
    reporting_category_2: yup.string(),
    reporting_category_3: yup.string(),
    upsell_products: yup.array(),
    upsell_bundles: yup.array(),
    algolia_tags: yup.array(),
  }),
});

export interface ProductFormSchema {
  // BASIC INFORMATION
  is_visible: boolean;
  name: string;
  categories: ProductCategory[]; // Subset of categories - only the subcategories of Menu1.
  zones: ProductCategory[]; // Subset of categories - only the subcategories of Zones.
  sku: string;
  weight: number;
  description: string;
  // PRICING
  price: number;
  cost_price: number;
  // SEO
  page_title: string;
  meta_description: string;
  // CUSTOM FIELDS
  custom_fields: {
    display_name: string;
    display_region: string;
    modal_promo_banner_text: string;
    display_badge: string;
    display_tasting_tags: string;
    display_volume: string;
    display_alcoholic_content: string;
    pack_type: string;
    parent_product_sku: string;
    standard_drink_count: number;
    menu_tile_promo_text: string;
    save_text: string;
    display_menu_tile: boolean;
    short_description: string;
    brand: string;
    is_bundle?: boolean;
    product_lists?: string;
    reporting_category_1: string;
    reporting_category_2: string;
    reporting_category_3: string;
    upsell_products: any;
    upsell_bundles: any;
    algolia_tags: string[];
  };
}

export interface Dynamic {
  [key: string]: any;
}
